import { render } from "./ArrowUpRight.vue?vue&type=template&id=518971f5"
import script from "./ArrowUpRight.vue?vue&type=script&lang=js"
export * from "./ArrowUpRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__